import './AboutPage.css'
import About from './About'

function AboutPage() {
    return (
        <>
            <div className="aboutPageSection">

                <div className="about-hero">
                    <div className="about-hero-overlay">
                        <p className="about-hero-label">Meet Your Agent</p>
                        <h1 className="about-hero-title">About Me</h1>
                    </div>
                </div>

                <div className="about-bio-section">
                    <div className="about-bio-inner">
                        <div className="about-bio-accent">
                            <div className="about-accent-line" />
                            <span className="about-accent-year">Est. 2012</span>
                        </div>
                        <div className="about-bio-content">
                            <p className="about-bio-lead">
                                Growing up in the Czech Republic and travelling across Europe gave me an eye for design, a love for history, and an appreciation for architecture.
                            </p>
                            <p className="about-bio-body">
                                Moving across the Atlantic to sunny Florida at only 19 — after a working experience as an Au-Pair in England — I was ready to see the world. Launching my career in real estate in 2012, my expertise, work ethic, honesty, integrity, and attention to detail has contributed to innumerable successful closings over the years.
                            </p>
                            <p className="about-bio-body">
                                With over a decade of experience representing both buyers and sellers, I continue to place my clients' interests first by staying informed and in touch with current trends, solutions, and strategies in what has become a highly competitive market.
                            </p>
                            <p className="about-bio-body">
                                I am a proud mom of 3 children and recently celebrated my 26th wedding anniversary. I currently live in the beautiful city of Canyon Lake, where I enjoy evening walks with my German shepherd, paddle boarding, boating, and resort-style living.
                            </p>

                            <div className="about-stats">
                                <div className="about-stat">
                                    <span className="stat-number">10+</span>
                                    <span className="stat-label">Years Experience</span>
                                </div>
                                <div className="about-stat-divider" />
                                <div className="about-stat">
                                    <span className="stat-number">100+</span>
                                    <span className="stat-label">Clients Served</span>
                                </div>
                                <div className="about-stat-divider" />
                                <div className="about-stat">
                                    <span className="stat-number">SoCal</span>
                                    <span className="stat-label">Local Expert</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <About />

                <div className="about-cta">
                    <p className="about-cta-text">Ready to start your real estate journey?</p>
                    <a href="/Contact" className="about-cta-button">Get In Touch</a>
                </div>

            </div>
        </>
    )
}

export default AboutPage
